import { useParams } from "react-router-dom";
import Stepper from "../components/Stepper/Stepper";

export default function EditResidentPage() {
  const { filialId } = useParams();
  // key: si se navega de una filial a otra, el asistente arranca de cero.
  return <Stepper key={filialId} filialId={filialId} />;
}
